module.exports = __webpack_public_path__ + "img/7.1838a1be.svg";